import Data from 'react-k2-api/Api/Data'
import PrimaryKey from 'react-k2-api/Api/PrimaryKey'
import { Type } from 'class-transformer'
import TK2UserLookupDM from './TK2UserLookupDM'

/**
 * Kredity zákazníka - porušení
 */
export default class TCustomerCreditViolationDM extends Data {
	public static className = 'TCustomerCreditViolationDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	public static isHeader = false

	/**
	 * Kredit
	 */
	CreditRID?: number

	/**
	 * Čas a datum
	 */
	ViolatedOn?: Date

	/**
	 * Doklad
	 */
	DocumentRID?: number

	/**
	 * Číslo
	 */
	RID?: number

	/**
	 * Částka
	 */
	Amount?: number

	/**
	 * Typ dokladu
	 */
	DocumentTypeId?: number

	/**
	 * Kredit
	 */
	MasterRID?: number

	/**
	 * undefined
	 */
	RecordMod?: number

	/**
	 * undefined
	 */
	RecordES?: number

	/**
	 * Číslo
	 */
	RecordID?: number

	/**
	 * undefined
	 */
	RecordState?: number

	/**
	 * s
	 */
	SelectionImgCalc?: string

	/**
	 * LegislationContext
	 */
	LegislationContextCalc?: number

	/**
	 * Datum
	 */
	CurrentDateCalc?: Date

	/**
	 * Čas
	 */
	CurrentTimeCalc?: Date

	/**
	 * Doklad
	 */
	DocumentCalc?: string

	/**
	 * Uživatel
	 */
	@Type(() => TK2UserLookupDM)
	ViolatedById?: TK2UserLookupDM
}